import FilterLogicModal from "../../components/modal/campaignListModals/filterLogicModal/filterLogicModal";
import React, { useEffect, useState, } from "react";
import { useSelector } from "react-redux";
import { useRef } from "react";
import CalenderComponent from "../../components/calender/Calender";
import closeIcon from "../../assets/icons/close_icon.png";
import { useGlobalContext } from "../../context/global";
import selectSideIcon from "../../assets/icons/select-btn-side-grey-icon.png";
import CalenderIconForCampaignList from "../../assets/icons/calender-icon-for-campaignlist.svg";
import Chart from "../../components/Reports/Chart";
import cubejs from "@cubejs-client/core";
import useToken  from "../../helper/Reports/useToken";
import ReportFilters from "../../components/Reports/Filters";
import SectionTitle from "../../components/sectionTitle";
import previousDays from "../../helper/Reports/common";
import Loader from "../../components/loader";
import Breadcrumb from '../../components/Breadcrumb/ReportsBreadCrumb';
import Canvas from '../../helper/Screenshot/canvas'
import downloadIcon from "../../assets/svgs/download.svg";
import useInitialLoad from '../../hooks/useInitialLoad';
import {dataQueryParser, formatPieChartData , createQueryURL , getSearchParamsObject , objectoFiltering} from "../../components/Reports/Components/utils";
import { useSearchParams } from "react-router-dom";
import useUserDetails from "../../helper/userData/useUserDetails";
import {
  buildAdGroupReportExportQueryBody,
  exportAdGroupReport,
  getAdGroupReportVisibleColumnKeys,
} from "../../helper/PageWiseExportLogic/adGroupReportExport";
import { openRequestTrackingPage } from "../../helper/common/openRequestTrackingPage";
import {
  Box,
  FormControl,
  MenuItem,
  Select,
  Typography,
} from "@mui/material";
import CustomPagination from "../../components/CustomPagination/CustomPagination";
import { toast } from "react-toastify";

const PAGE_SIZE_OPTIONS = [50, 100, 200, 300, 500];

const AdGroupReport = (props) => {
    const [token, refresh] = useToken("");
    const { cubeToken, setCubeToken } = useGlobalContext();
    const { clientAccountId } = useGlobalContext();
    const cubejsApi = cubejs(cubeToken,{ apiUrl: process.env.REACT_APP_CUBE_JS_URL});
    const [tableView, setTableView] = useState("table");
    const [showFilters, setShowFilters] = useState(true)
    const allParams = new URLSearchParams(window.location.search);
    const paramsObject = getSearchParamsObject(allParams);
    const previousFiltering = objectoFiltering(paramsObject,"client_daily_adset_amazon")
    const viewType = allParams.get('viewtype') ?? 'Performance View';
    const [currentViewType, setCurrentViewType] = useState(viewType);
    const isComparisonView = currentViewType === 'Comparison View';
    const [initialLoad,setInitialLoad] = useInitialLoad()
    const [searchParams,setSearchParams] = useSearchParams({});
    const { calendarDate, setCalendarDate, dateDifference, setDateDifference,applyCalendar, multiCalendarDate } = useGlobalContext();
    const formatDate = (date) => {
        const offset = date.getTimezoneOffset()
        date = new Date(date.getTime() - (offset*60*1000))
        return date.toISOString().split('T')[0].toString()
    };
    let startDate = formatDate(multiCalendarDate.selection1.startDate);
    let endDate = formatDate(multiCalendarDate.selection1.endDate);
    let startDatePrevious = formatDate(
          multiCalendarDate.selection2.startDate
        );
    let endDatePrevious = formatDate(multiCalendarDate.selection2.endDate);
    const cubeQueryTimeDimensionsFormatted = !isComparisonView ? [{dimension:"client_daily_adset_amazon.obDate",dateRange: [
      formatDate(calendarDate[0].startDate),
      formatDate(calendarDate[0].endDate),
    ]}] : [{dimension:"client_daily_adset_amazon.obDate",compareDateRange:[
      [startDate, endDate],
      [startDatePrevious, endDatePrevious],
    ]}]
    const dashboardSideBarVisibiltyState = useSelector(
        (state) => state.dashboardData.dashboardSideBarVisibiltyState
    );
    const filterModalInCampaignListVisibilty = useSelector(
        (state) => state.campaignListData.filterModalInCampaignListVisibilty
    );
    const [showCustomDateBox, setShowCustomDateBox] = useState(false);
    const [isFilterVisible, setIsFilterVisible] = useState(false);
    const [campaignType, setCampaignType] = useState([]);
    const [campaignFormat, setCampaignFormat] = useState([]);
    const [targetingType, setTargetingType] = useState([]);
    const [productSet, setProductSet] = useState([]);
    const [adgroupStatus, setAdgroupStatus] = useState([]);
    const [portfolioName, setPortfolioName] = useState([]);
    const [campaignName, setCampaignName] = useState([]);
    const [drrView, setDrrView] = useState("")

    const [isLoaderVisible, setIsLoaderVisible] = useState(false);
    const [paginationLimit, setPaginationLimit] = useState(50);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalCount, setTotalCount] = useState(0);
    const [cubeQueryMeasure, setCubeQueryMeasure] = useState([
        "client_daily_adset_amazon.cost",
        "client_daily_adset_amazon.costDRR",
        "client_daily_adset_amazon.impressions",
        "client_daily_adset_amazon.impressionsDRR",
        "client_daily_adset_amazon.clicks",
        "client_daily_adset_amazon.clicksDRR",
        "client_daily_adset_amazon.ctr",
        "client_daily_adset_amazon.ctrDRR",
        "client_daily_adset_amazon.cpc",
        "client_daily_adset_amazon.cpcDRR",
        "client_daily_adset_amazon.cpm",
        "client_daily_adset_amazon.cpmDRR",
        "client_daily_adset_amazon.conversions14d",
        "client_daily_adset_amazon.conversions14dDRR",
        "client_daily_adset_amazon.conversion_rate",
        "client_daily_adset_amazon.conversion_rateDRR",
        "client_daily_adset_amazon.sales14d",
        "client_daily_adset_amazon.sales14dDRR",
        "client_daily_adset_amazon.average_order_value",
        "client_daily_adset_amazon.average_order_valueDRR",
        "client_daily_adset_amazon.acos",
        "client_daily_adset_amazon.acosDRR",
        "client_daily_adset_amazon.roas",
        "client_daily_adset_amazon.roasDRR",
      ]);
    const [cubeQueryOrder, setCubeQueryOrder] = useState([
        [
          "client_daily_adset_amazon.cost",
          "desc"
        ]
      ]);

    const [cubeQueryDimensions, setCubeQueryDimensions] = useState([
        "client_daily_adset_amazon.adGroupNameDimension",
      ]);
    const [cubeQueryTimeDimensions, setCubeQueryTimeDimensions] = useState(cubeQueryTimeDimensionsFormatted);
    const [cubeQueryFilters, setCubeQueryFilters] = useState([
        {
          member: "client_daily_adset_amazon.profileId",
          operator: "equals",
          values: [clientAccountId],
        },
        ...previousFiltering
      ]);
    const [resultSet, setResultSet] = useState({});
    const totalPages = Math.max(1, Math.ceil(totalCount / paginationLimit));
    const [chartFilters, setChartFilters] = useState({
      spend:"cost",
      revenue:"sales14d"
    })
    var spendResultSet = formatPieChartData(resultSet, chartFilters.spend,"client_daily_adset_amazon", "adGroupNameDimension");
    var revenueResultSet = formatPieChartData(resultSet, chartFilters.revenue,"client_daily_adset_amazon", "adGroupNameDimension");
    const getAdgroupMemberKey = (type) => {
      const mapper = {
        profileId: "profileId",
        campaignId: "campaignIdDimension",
        campaignName: "campaignNameDimension",
        adGroupId: "adGroupIdDimension",
        adGroupName: "adGroupNameDimension",
        campaignType: "campaignTypeDimension",
        targetingType: "targetingTypeDimension",
        productSet: "productSetDimension",
        portfolioId: "portfolioIdDimension",
        portfolioName: "portfolioNameDimension",
        campaignFormat: "campaignFormatDimension",
        campaignStatus: "campaignStatusDimension",
        adgroupStatus: "adgroupStatusDimension",
        account: "account",
        parseClientId: "parseClientId",
        obDate: "obDate",
        week: "weekDimension",
        month: "monthDimension",
      };
      return mapper[type] ?? type;
    };
    const calenderIconRefForCampaignlist = useRef(null);
    const enabledfilters = ["Campaign Type","Campaign Names","Campaign Format","Targeting Type","Product Set","Adgroup Status","Portfolio Name"]
    const [isExportRedirectMode, setIsExportRedirectMode] = useState(false);
    const [isExportDownloading, setIsExportDownloading] = useState(false);
    const [userDetails] = useUserDetails();
    const userPlatform = JSON.parse(localStorage.getItem("user_platform")) ?? "amazon";

    const closeCalender = (e) => {
        if (
            calenderIconRefForCampaignlist.current &&
            showCustomDateBox &&
            !calenderIconRefForCampaignlist.current.contains(e.target)
        ) {
            setShowCustomDateBox(false);
        }
    };


    const dateInputClickHandler = (e) => {
        setShowCustomDateBox(!showCustomDateBox);
    };


    useEffect(() => {
        document.addEventListener("mousedown", closeCalender);
        return () => {
            // Cleanup the event listener
            document.removeEventListener("mousedown", closeCalender);
        };
    }, [showCustomDateBox]);

    

    useEffect(() => {
        if(currentViewType !== "Comparison View") {
            
            const startDate = formatDate(calendarDate[0].startDate);
            const endDate = formatDate(calendarDate[0].endDate);
            if (startDate !== cubeQueryTimeDimensions[0]["dateRange"][0] || endDate !== cubeQueryTimeDimensions[0]["dateRange"][1]) {
                setIsLoaderVisible(true)
                setCubeQueryTimeDimensions((prev) => {
                    let data = [...prev];
                    data[0]["dateRange"] = [startDate, endDate];
                    return data;
                });
            }
        } 
    }, [applyCalendar]);

    useEffect(() => {
        if(currentViewType === "Comparison View") {
            let startDate = formatDate(multiCalendarDate.selection1.startDate);
            let endDate = formatDate(multiCalendarDate.selection1.endDate);
            let startDatePrevious = formatDate(multiCalendarDate.selection2.startDate);
            let endDatePrevious = formatDate(multiCalendarDate.selection2.endDate);
            let apiDateRange = cubeQueryTimeDimensions[0]["compareDateRange"]
            if (startDate !== apiDateRange[0][0] || endDate !== apiDateRange[0][1] || startDatePrevious !== apiDateRange[1][0] || endDatePrevious !== apiDateRange[1][1]) {
                setIsLoaderVisible(true)
                setCubeQueryTimeDimensions((prev) => {
                    let data = [...prev];
                    data[0]["compareDateRange"] = [[startDate, endDate], [startDatePrevious, endDatePrevious]];
                    return data;
                });
            } 
        }
    },[applyCalendar])

    useEffect(()=>{
      if(cubeToken) {
        cubejsApi.load({
            measures: cubeQueryMeasure,
            order: cubeQueryOrder,
            dimensions: cubeQueryDimensions,
            filters: cubeQueryFilters,
            timeDimensions: cubeQueryTimeDimensions,
            limit: paginationLimit,
            offset: (currentPage - 1) * paginationLimit,
            total: true,
          },{
            headers: {
              'Access-Control-Allow-Origin': true
            }
          }).then((resultSet) => {
            setResultSet(resultSet);
            setTotalCount(resultSet?.loadResponse?.results?.[0]?.total ?? 0);
            setIsLoaderVisible(false)
            setInitialLoad(false)
            if(currentViewType === 'Comparison View') {
                setTableView("ComparisonTable")
            } else {
                setTableView("table")
            }
          }).catch((error) => {
            if(error.message === 'Invalid token') {
                setCubeToken(false)
                localStorage.setItem("cubeToken", null);
                refresh()
            }
          });
          }

    },[cubeQueryFilters, cubeQueryTimeDimensions, cubeToken, cubeQueryOrder, currentPage, paginationLimit])

    const handlePageChange = (pageNumber) => {
      setIsLoaderVisible(true);
      setCurrentPage(pageNumber);
    };

    const handlePageLimitChange = (event) => {
      setIsLoaderVisible(true);
      setPaginationLimit(Number(event.target.value));
      setCurrentPage(1);
    };

    const filterCampaigns = (e, type) => {
        setCurrentPage(1);
        setIsLoaderVisible(true)
        const memberKey = getAdgroupMemberKey(type);
        const parsedQueryFilters = dataQueryParser(
          JSON.parse(JSON.stringify(cubeQueryFilters)),
          e,
          memberKey,
          "client_daily_adset_amazon"
        );
        const parsedParams = createQueryURL(parsedQueryFilters);
        parsedParams['viewtype'] = currentViewType
        const previousParams = new URLSearchParams(window.location.search)
        if(previousParams.get('metricViewType')) {
          parsedParams['metricViewType'] = previousParams.get('metricViewType')
        }
        setCubeQueryFilters((prev)=>{
            let data = dataQueryParser(prev,e,memberKey,"client_daily_adset_amazon")
            return data;
         })
        setSearchParams(parsedParams)
         if (type === "campaignType") {
            setCampaignType(e);
          } else if (type === "campaignFormat") {
            setCampaignFormat(e);
          } else if (type === "targetingType") {
            setTargetingType(e);
          } else if (type === "productSet") {
            setProductSet(e);
          } else if (type === "adgroupStatus") {
            setAdgroupStatus(e);
          } else if (type === "portfolioName") {
            setPortfolioName(e);
          } else if (type === "campaignName") {
            setCampaignName(e);
          }

    };

    useEffect(() => {
        setIsFilterVisible(filterModalInCampaignListVisibilty);
    }, [filterModalInCampaignListVisibilty]);

    const handleComparisonView = (type) => {
        setCurrentPage(1);
        if(type === 'Comparison View') {
            setCubeQueryTimeDimensions([{
                  dimension: "client_daily_adset_amazon.obDate",
                  compareDateRange: [[startDate, endDate], [startDatePrevious, endDatePrevious]],
                },
              ]);
              setIsLoaderVisible(true)
        } else if(type !== 'Comparison View' && currentViewType === 'Comparison View') {
            setCubeQueryTimeDimensions([{
                dimension: "client_daily_adset_amazon.obDate",
                dateRange: [formatDate(calendarDate[0].startDate), formatDate(calendarDate[0].endDate)],
              },
            ]);
            setIsLoaderVisible(true)
        }
        setCurrentViewType(type)
    }

    function dataFilter(data) {
        setCurrentPage(1);
        setIsLoaderVisible(true)
        const table = "client_daily_adset_amazon.";
        let tempFilters = [...cubeQueryFilters];
        Object.entries(data).forEach(([key, value]) => {
          tempFilters.forEach((x, i) => {
            if (x.member === `${table}${key}`) {
              tempFilters.splice(i, 1);
            }
          });
          if (value.min) {
            tempFilters.push({
              member: `${table}${key}`,
              operator: 'gte',
              values: [parseFloat(value.min)]
            });
          }
          if (value.max) {
            tempFilters.push({
              member: `${table}${key}`,
              operator: 'lte',
              values: [parseFloat(value.max)]
            });
          }
        })
        setCubeQueryFilters(tempFilters);
      }

      const handleDownload = () => {
        Canvas({ name: 'ad-group-report' });
      };

      const handleAdGroupReportExportClick = async () => {
        if (isExportRedirectMode) {
          openRequestTrackingPage();
          return;
        }

        if (isComparisonView) {
          return;
        }

        const exportTotalCount =
          totalCount ?? resultSet?.loadResponse?.results?.[0]?.total ?? 0;
        if (exportTotalCount <= 0) {
          toast.info("No records available for export.");
          return;
        }

        const clientId = JSON.parse(localStorage.getItem("clientId"));
        const queryBody = buildAdGroupReportExportQueryBody({
          cubeQueryMeasures: cubeQueryMeasure,
          cubeQueryDimensions,
          cubeQueryOrder,
          cubeQueryFilters,
          cubeQueryTimeDimensions,
        });

        await exportAdGroupReport({
          clientId,
          userPlatform,
          triggeredBy:
            userDetails?.user?.email ?? localStorage.getItem("email") ?? "",
          totalCount: exportTotalCount,
          queryBody,
          visibleColumnKeys: getAdGroupReportVisibleColumnKeys({
            cubeQueryMeasures: cubeQueryMeasure,
            cubeQueryDimensions,
          }),
          isComparison: isComparisonView,
          setIsExporting: setIsExportDownloading,
          onExportSuccess: () => setIsExportRedirectMode(true),
        });
      };

      useEffect(() => {
        setIsExportRedirectMode(false);
      }, [
        cubeQueryFilters,
        cubeQueryTimeDimensions,
        cubeQueryOrder,
        cubeQueryMeasure,
        cubeQueryDimensions,
        applyCalendar,
        currentViewType,
      ]);

      const handleDrrView = (value, type) => {
        setDrrView(value)
        if(value !== 'drr') {
            setChartFilters({spend:"cost",revenue:"sales14d"})
        } else {
            setChartFilters({spend:"costDRR",revenue:"sales14dDRR"})
        }
      };

    function handleSearch(data) {
        setCurrentPage(1);
        let prevData = [...cubeQueryFilters]
          prevData.forEach((x, i) => {
            if (x.member === cubeQueryDimensions[0]) {
              prevData.splice(i, 1);
            }
          });
          if(data.input) {
            prevData.push({
                member: cubeQueryDimensions[0],
                operator: data.select,
                values: [data.input],
              });
          }
          setShowFilters(data)
          setCubeQueryFilters(prevData);
      }
    return (
        <div
            className={
                dashboardSideBarVisibiltyState
                    ? "main-content-container-onopen-mode"
                    : "main-content-container-oncolapse-mode"
            }
            id="main-box" >
            <Loader visible={initialLoad}></Loader>
            <div style={{marginLeft: "auto"}}>
                <button
                    className="date-container date-btn-campaignlist d-none"
                    onClick={dateInputClickHandler}
                >
                    <div className="d-flex justify-conntent-center">
                        <span className="date-btn-text">
                            {dateDifference}
                        </span>
                    </div>
                    <button className="btn-calender-img-holder">
                        <span className="">
                            <img
                                className="dropdown-img-for-select"
                                src={selectSideIcon}
                                alt={"SelectSideIcon"}
                            ></img>

                            <img
                                className="calender-icon-for-campaignlist"
                                src={CalenderIconForCampaignList}
                                alt={"CalendarIcon"}
                            ></img>
                        </span>
                    </button>
                </button>
            </div>

            <div
                ref={calenderIconRefForCampaignlist}
                className={
                    showCustomDateBox
                        ? "calender-inclasslist-container"
                        : "hide"
                }
            >
                <CalenderComponent setShowCustomDateBox={setShowCustomDateBox}></CalenderComponent>
                <span className="calender-close-icon-campaignlist">
                    <img
                        onClick={() => setShowCustomDateBox(false)}
                        src={closeIcon}
                        alt={"CloseIcon"}
                    ></img>
                </span>
            </div>
            
            <Breadcrumb />
            <SectionTitle sectionTitleHeading='Ad Group Report'></SectionTitle>
            <div className="d-flex justify-content-between mt-4 mb-4 gap-4 position-relative" id="downloadChart" >
            <div onClick={handleDownload} className="downloadChartWrapper pie" id="downloadChartWrapper">
                    <img src={downloadIcon} className="cursor-pointer-global DownloadIcon" alt="overview-settings-tile" />
            </div>
                <div  className="w-100 min-h-300 pie-container">
                <h4 className="sub-heading-pie f-20 p-4">Spends</h4>
                    <Chart type="apexpie" resultSet={spendResultSet} classes={'marketing-reports'} />
         
                </div>
                <div className="w-100 min-h-300 pie-container">
                    <h4 className="sub-heading-pie f-20 p-4">Revenue</h4>
                    <Chart type="apexpie" resultSet={revenueResultSet} classes={'marketing-reports'} />
                </div>

            </div>

            <ReportFilters handleDropdown={filterCampaigns} enabledfilters={enabledfilters} />

            <div>
                {
                    <FilterLogicModal
                        filterFor="campaignlist"
                        show={isFilterVisible}
                    ></FilterLogicModal>
                }
            </div>

            <div className="">
                    <Chart shimmerEffect={isLoaderVisible} type={tableView} resultSet={resultSet} classes={'marketing-reports'} FunnelViews={["Performance View","Funnel View","Comparison View","Custom View"]} handleComparisonView={handleComparisonView} CurrentViewType={currentViewType} page="match-type" dataFilter={dataFilter} drrView={handleDrrView} drrViewType={drrView} handleSearch={handleSearch} showFilter={showFilters}
            useExternalPagination={true}
            backendExport={{
              onExportClick: handleAdGroupReportExportClick,
              isExportRedirectMode,
              isExportDownloading,
            }}
            />
            {!isLoaderVisible &&
              !initialLoad &&
              (totalCount > 0 || Object.keys(resultSet).length > 0) && (
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    gap: 1,
                    py: 2,
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: 1,
                      color: "#4f5366",
                    }}
                  >
                    <Typography variant="body2" sx={{ fontSize: "12px" }}>
                      Page Size
                    </Typography>
                    <FormControl size="small" sx={{ minWidth: 80 }}>
                      <Select
                        value={paginationLimit}
                        onChange={handlePageLimitChange}
                        disabled={isLoaderVisible}
                        sx={{
                          height: 36,
                          fontSize: "12px",
                          color: "#333333",
                        }}
                        MenuProps={{ disableScrollLock: true }}
                      >
                        {PAGE_SIZE_OPTIONS.map((option) => (
                          <MenuItem
                            key={option}
                            value={option}
                            sx={{ fontSize: "12px" }}
                          >
                            {option}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Box>

                  <CustomPagination
                    currentPage={currentPage}
                    totalPages={totalPages}
                    onPageChange={handlePageChange}
                    lazyLoading={isLoaderVisible}
                    totalItems={totalCount}
                    itemsPerPage={paginationLimit}
                  />
                </Box>
              )}
            </div>
        </div>
    )
}

export default AdGroupReport;